import { observer } from 'mobx-react-lite';
import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

import { StyledCardContent } from '../SeenThings';
import { useSeenThingsPresenter } from '../SeenThingsPresenter';
import SeenThingsCard from './ProductCard';
import SeenThingsBrandCard from './SeenThingsBrandCard';

const StyledView = styled.View`
  margin-bottom: 17.63px;
`;

const BrandDetails = () => {
  const { selectedBrand } = useSeenThingsPresenter();
  return (
    <View>
      {selectedBrand.value?.brand && (
        <StyledView>
          <SeenThingsBrandCard
            item={selectedBrand}
            size='s'
            name={selectedBrand.value?.brand}
          />
        </StyledView>
      )}
      <StyledCardContent>
        {selectedBrand.value?.products &&
          selectedBrand.value?.products?.map((product) => (
            <SeenThingsCard
              url={product.productImage}
              path={product.path}
              key={product.productId}
            />
          ))}
      </StyledCardContent>
    </View>
  );
};

export default observer(BrandDetails);
